import { BOOKMARKS_COUNT_KEY } from "@/Groups/Polymarket/private/constants/config";

export const updateBookmarksCount = (state) => {
  state.bookmarksCount = state.bookmarksMap.length;
  localStorage.setItem(BOOKMARKS_COUNT_KEY, state.bookmarksCount);
};